import Joi from 'joi';

const isValidRut = (rut) => {
  if (!/^\d{7,8}-[\dkK]$/.test(rut)) return false;

  const [body, dvRaw] = rut.split('-');
  const dv = dvRaw.toUpperCase();

  let sum = 0;
  let multiplier = 2;

  for (let i = body.length - 1; i >= 0; i--) {
    sum += Number(body[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const remainder = 11 - (sum % 11);
  const expectedDv =
    remainder === 11 ? '0' : remainder === 10 ? 'K' : String(remainder);

  return dv === expectedDv;
};

export const rutValidation = Joi.extend({
  messages: {
    invalidRut: 'Rut inválido (formato sin puntos y con guión: 12345678-9)',
  },
  type: 'rut',
  rules: {
    validateRut: {
      validate(value, helpers) {
        if (value.includes('.')) return helpers.error('invalidRut');
        if (isValidRut(value) && value !== '') return true;
        return helpers.error('invalidRut');
      },
    },
  },
});
